import { render } from "./DesignSystemPage.vue?vue&type=template&id=04fe1844&scoped=true"
import script from "./DesignSystemPage.vue?vue&type=script&lang=js"
export * from "./DesignSystemPage.vue?vue&type=script&lang=js"

import "./DesignSystemPage.vue?vue&type=style&index=0&id=04fe1844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fe1844"]])

export default __exports__